import { Firmness } from "./types/Data";

export const calculateBMI = (weight: number, height: number) => weight / (height ** 2);

export function getMattressFirmnessByErgonomicIndex (ergonomicIndex: number): Firmness {

	if (ergonomicIndex <= 48) {
		return 'h2';
	}

	if (ergonomicIndex <= 62) {
		return 'h3';
	}

	return 'h4';
}

export function getMattressFirmnessByBMI (bmi: number): Firmness {

	if (bmi <= 26) {
		return 'h2';
	}

	if (bmi <= 31) {
		return 'h3';
	}

	return 'h4';
}


export function mapRange (value: number, inputMin: number, inputMax: number, outputMin: number, outputMax: number) {
	return ((value - inputMin) * (outputMax - outputMin) / (inputMax - inputMin)) + outputMin;
}
